// extracted by mini-css-extract-plugin
export default {"container":"FiltersBlock_container__7WCgg"};